import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$slug/department/members')({
  component: Outlet
});
